import './App.css';

import { MsalProvider } from '@azure/msal-react';
import Pages from './Pages';

function App({ instance }) {
	return (
		<MsalProvider instance={instance}>
			<Pages />
		</MsalProvider>
	);
}

export default App;
